function redirectToCheckout(button, variantMap) {     
    if (button) {
        button.classList.add("btn--loading");
    }

    const selectedBraceletColor = document.querySelector('block-variant-picker input[data-index="option1"]:checked').value;
  
    console.log(selectedBraceletColor)
    const braceletVariantId = variantMap.bracelet[selectedBraceletColor];
    const ringVariantId = variantMap.ring[selectedBraceletColor];

    let baseUrl = `https://hizbe.com/cart/${braceletVariantId}:1,${ringVariantId}:1`;
    if(document.querySelector('#gift-box-option:checked')) {
     baseUrl = baseUrl + ',40589612154952:1';
    }

    const queryParams = window.location.search;

    const finalUrl = baseUrl + queryParams;

    console.log('Redirecting to:', finalUrl);
    window.location.href = finalUrl;

    return;
}

document.addEventListener("DOMContentLoaded", function () {
  const stickyButton = document.querySelector(".sticky-button");
  const fixedButton = document.querySelector(".btn--fixed");

  if (!stickyButton || !fixedButton) return;

  function checkButtonVisibility() {
    const rect = fixedButton.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset;
    const scrollBottom = document.documentElement.scrollHeight - (scrollTop + window.innerHeight);

    const footer = document.querySelector(".shopify-section-group-footer-group");
    const footerHeight = footer ? footer.offsetHeight : 0;

    const isFixedOutOfView = rect.bottom < 0;

    if (
      isFixedOutOfView &&
      scrollBottom > footerHeight
    ) {
      stickyButton.classList.add("sticky-button--active");
    } else {
      stickyButton.classList.remove("sticky-button--active");
    }
  }

  window.addEventListener("scroll", checkButtonVisibility);
  checkButtonVisibility();
});




const TIMER_KEY = 'giftBoxTimerStart';
const COUNTDOWN_DURATION = 15 * 60 * 1000; // 15 minutes
const RESET_INTERVAL = 24 * 60 * 60 * 1000; // 24 hours

function initializeTimer() {
 let startTime = localStorage.getItem(TIMER_KEY);
 const now = Date.now();
 
 if (!startTime) {
   // First time - save current time as start time
   startTime = now;
   localStorage.setItem(TIMER_KEY, startTime);
 } else {
   startTime = parseInt(startTime);
   
   // Check if 24 hours have passed since the timer started
   if (now - startTime >= RESET_INTERVAL) {
     // Reset timer - start new 15 minute countdown
     startTime = now;
     localStorage.setItem(TIMER_KEY, startTime);
   }
 }
 
 const countdownElement = document.querySelector('.timer-secret-offer');
 
 function updateTimer() {
   const now = Date.now();
   const timeLeft = Math.max(0, COUNTDOWN_DURATION - (now - startTime));
   
   const hours = Math.floor(timeLeft / (1000 * 60 * 60));
   const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
   const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
   
   countdownElement.textContent = 
     `${String(hours).padStart(2, '0')}:` +
     `${String(minutes).padStart(2, '0')}:` +
     `${String(seconds).padStart(2, '0')}`;
   
   if (timeLeft <= 0) {
     clearInterval(timerInterval); 
     document.querySelector('.gift-box-banner').style.pointerEvents = 'none';
     countdownElement.textContent = 'ALMOST EXPIRED';
   }
 }
 
 updateTimer(); // Initial call
 const timerInterval = setInterval(updateTimer, 1000);
}

  document.addEventListener('DOMContentLoaded', initializeTimer);